// Import Dependencies
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { PATH_TRIAL_LOGIN, PATH_SIGNUP_SUCCESS } from '~/common/utils/consts.js';

// Import Local Styles
import styles from './coupon-banner.css';

@withRouter
@inject('promoCodeStore', 'trialSignupStore', 'cmsStore')
@observer
export default class CouponBanner extends Component {
    renderCopy() {
        const { promo } = this.props.promoCodeStore;
        const { promoLabels } = this.props.cmsStore;
        return (
            <div className={styles['coupon-message']}>
                {promo && promo.Message ? promo.Message : promoLabels.promoMessage}
            </div>
        );
    }

    renderAmount() {
        const { promoMaxAmount, activePromo } = this.props.promoCodeStore;
        const { promoLabels } = this.props.cmsStore;
        return (
            promoMaxAmount &&
                <div className={styles['amount-container']}>
                    {
                       activePromo?.Name || promoLabels.promoHeader || `Up to $${promoMaxAmount} off!`
                    }
                </div>
        );
    }

    closeBanner() {
        this.props.promoCodeStore.setIsBannerOpen(false);
    }

    render() {
        const { cmsStore, promoCodeStore, history } = this.props;
        const { isBannerOpen } = promoCodeStore;
        const { hasLoaded } = cmsStore;
        const { location: { pathname } } = history;

        if (
            pathname !== PATH_TRIAL_LOGIN || pathname !== PATH_SIGNUP_SUCCESS
        ) return false;

        return (hasLoaded &&
            <div
                className={`${
                    styles.wrapper} ${
                    isBannerOpen ? styles.open : ''
                }`}
                data-test="coupon-banner"
            >
                <div className={styles['text-container']}>
                    {this.renderAmount()}
                    {this.renderCopy()}
                </div>
                <span className={styles.close} onClick={() => this.closeBanner()}>×</span>
            </div>
        );
    }
}
